import React, { Component } from 'react';

import classNames from 'classnames';
import { Icon } from 'components/ClubComponents';
import PropTypes from 'prop-types';

import './Checkbox.scss';

export const ICON_CHECKED = { name: 'check', size: 12 };
export const ICON_INDETERMINATE = { name: 'minus', size: 12 };

class Checkbox extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
    indeterminate: PropTypes.bool,
    onChange: PropTypes.func,
    children: PropTypes.node,
    name: PropTypes.string,
    published: PropTypes.bool,
    icon: PropTypes.string,
    positionIcon: PropTypes.string,
    classIcon: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func
  };

  static defaultProps = {
    positionIcon: '',
    icon: '',
    classIcon: '',
    indeterminate: false
  };

  get isIndeterminate() {
    const { indeterminate, checked } = this.props;

    return indeterminate && !checked;
  }

  get isDisabled() {
    const { disabled } = this.props;

    return disabled;
  }

  renderIcon() {
    const iconProps = this.isIndeterminate ? ICON_INDETERMINATE : ICON_CHECKED;

    return <Icon {...iconProps} />;
  }

  render() {
    const {
      id,
      name,
      className,
      onChange,
      icon,
      positionIcon,
      classIcon,
      children,
      checked,
      onClick,
      ...props
    } = this.props;
    const classComponent = classNames(
      'check__container',
      {
        'check__container--indeterminate': this.isIndeterminate
      },
      {
        'check__container--disabled': this.isDisabled
      },
      className
    );

    const handleClick = (e) => {
      e.stopPropagation();

      onClick && onClick(e);
    };

    return (
      <label
        htmlFor={id}
        className={classComponent}
        data-test="ca-checkbox-container"
      >
        <input
          {...props}
          checked={checked || false}
          data-test="ca-checkbox-input"
          id={id}
          className="hot-form__input valid"
          key="checkbox__input"
          name={name}
          onChange={onChange}
          onClick={handleClick}
          type="checkbox"
        />

        <span
          key="checkbox__span"
          onClick={(e) => e.stopPropagation()}
          className="check"
        >
          {this.renderIcon()}
        </span>

        {icon && (
          <label
            htmlFor="checkbox__input"
            key="checkbox__input__label"
            className={`icon icon-${icon} icon--${positionIcon} ${classIcon}`}
          />
        )}

        {children && (
          <span key="checkbox__label" className="hot-form__label check__label">
            {children}
          </span>
        )}
      </label>
    );
  }
}

export default Checkbox;
